export { default } from "./SettingsLayout";
